const columns = [
    {
      swapFreeIslamic: "YES",
  
      title: 'Name',
      dataIndex: 'InstutionName',
  
    },
    {
      title: 'Phone No',
      dataIndex: 'ContactNumber',
  
    },
    {
      title: 'Registration No',
      dataIndex: 'RegistrationId',
  
    },
    {
      title: 'Joing date',
      dataIndex: 'createdAt',
    },
    {
      title: 'Instution Type',
      dataIndex: 'instutionType',
    },
    {
      title: 'State',
      dataIndex: 'State',
    },
    {
      title: 'District',
      dataIndex: 'District',
    },
    {
      title: 'Status',
      dataIndex: 'status',
    },
    {
      title: 'Actions',
      dataIndex: 'actions',
    }
  
  ];
  
  export default columns;
  
  
  